import {
  GET_CANCELLATION_REASON,
  GET_CANCELLATION_REASON_SUCCESS,
  GET_CANCELLATION_REASON_FAIL,
  ADD_CANCELLATION_REASON,
  ADD_CANCELLATION_REASON_SUCCESS,
  ADD_CANCELLATION_REASON_FAIL,
  UPDATE_CANCELLATION_REASON,
  UPDATE_CANCELLATION_REASON_SUCCESS,
  UPDATE_CANCELLATION_REASON_FAIL,
  DELETE_CANCELLATION_REASON,
  DELETE_CANCELLATION_REASON_SUCCESS,
  DELETE_CANCELLATION_REASON_FAIL,
  SET_CANCELLATION_REASON_FIELD_ERRORS,
} from './actionTypes'

// Get Cancellation Reason
export const getCancellationReason = () => ({
  type: GET_CANCELLATION_REASON,
})

export const getCancellationReasonSuccess = (cancellationReason) => ({
  type: GET_CANCELLATION_REASON_SUCCESS,
  payload: cancellationReason,
})

export const getCancellationReasonFail = (error) => ({
  type: GET_CANCELLATION_REASON_FAIL,
  payload: error,
})

// Add Cancellation Reason
export const addCancellationReason = (cancellationReason) => ({
  type: ADD_CANCELLATION_REASON,
  payload: cancellationReason,
})

export const addCancellationReasonSuccess = (cancellationReason) => ({
  type: ADD_CANCELLATION_REASON_SUCCESS,
  payload: cancellationReason,
})

export const addCancellationReasonFail = (error) => ({
  type: ADD_CANCELLATION_REASON_FAIL,
  payload: error,
})

// Update Cancellation Reason
export const updateCancellationReason = (cancellationReason) => ({
  type: UPDATE_CANCELLATION_REASON,
  payload: cancellationReason,
})

export const updateCancellationReasonSuccess = (cancellationReason) => ({
  type: UPDATE_CANCELLATION_REASON_SUCCESS,
  payload: cancellationReason,
})

export const updateCancellationReasonFail = (error) => ({
  type: UPDATE_CANCELLATION_REASON_FAIL,
  payload: error,
})

// Delete Cancellation Reason
export const deleteCancellationReason = (id) => ({
  type: DELETE_CANCELLATION_REASON,
  payload: id,
})

export const deleteCancellationReasonSuccess = (id) => ({
  type: DELETE_CANCELLATION_REASON_SUCCESS,
  payload: id,
})

export const deleteCancellationReasonFail = (error) => ({
  type: DELETE_CANCELLATION_REASON_FAIL,
  payload: error,
})

// Set Field Errors
export const setCancellationReasonFieldErrors = (errors) => ({
  type: SET_CANCELLATION_REASON_FIELD_ERRORS,
  payload: errors,
})
